import { fetchGet } from "..";
import { Racecourse } from "../../types/racecourse";
import { APIResponse } from "../../types/responses/APIResponse";

// all racecourses
export const getRacecourses = async (
  region?: string
): Promise<APIResponse<Racecourse[]>> => {
  return await fetchGet(`/racing/tracks`);
};

// single racecourse
export const getRacecourse = async (
  slug: string
): Promise<APIResponse<Racecourse>> => {
  return await fetchGet(`racing/tracks/${slug}`);
};

export const getRacecourseRaces = async (
  slug: string
): Promise<APIResponse<Racecourse>> => {
  return await fetchGet(`racing/tracks/${slug}/races`);
};

export const getRacecourseReplays = async (
  slug: string
): Promise<APIResponse<Racecourse>> => {
  return await fetchGet(`racing/tracks/${slug}/replays`);
};

export const getRacecourseFastResults = async (
  slug: string
): Promise<APIResponse<Racecourse>> => {
  return await fetchGet(`racing/track-fast-results/${slug}`);
};

export const getRacecourseResults = async (
  slug: string
): Promise<APIResponse<Racecourse>> => {
  return await fetchGet(`racing/tracks/${slug}/results`);
};
